import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Shell from './components/layout/Shell.svelte';
import { matchRoute } from './lib/router.svelte.ts';
import { getAppState } from './lib/stores/appState.svelte.ts';
import Home from './pages/Home.svelte';
import Log from './pages/Log.svelte';
import NursingSession from './pages/NursingSession.svelte';
import PumpingSession from './pages/PumpingSession.svelte';
import BottleFeed from './pages/BottleFeed.svelte';
import History from './pages/History.svelte';
import Storage from './pages/Storage.svelte';
import More from './pages/More.svelte';
import Settings from './pages/Settings.svelte';
import Profile from './pages/Profile.svelte';
import Children from './pages/Children.svelte';
import Health from './pages/Health.svelte';
import Analytics from './pages/Analytics.svelte';
import Reminders from './pages/Reminders.svelte';
import Sync from './pages/Sync.svelte';
import Donate from './pages/Donate.svelte';
import Export from './pages/Export.svelte';
import Onboarding from './pages/Onboarding.svelte';

function App($$anchor, $$props) {
	$.push($$props, true);

	const appState = $.derived(getAppState);
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			Onboarding(node_1, {});
			$.append($$anchor, fragment_1);
		};

		var alternate_1 = ($$anchor) => {
			var fragment_2 = $.comment();
			var node_2 = $.first_child(fragment_2);

			Shell(node_2, {
				children: ($$anchor, $$slotProps) => {
					var fragment_3 = $.comment();
					var node_3 = $.first_child(fragment_3);

					{
						var consequent_1 = ($$anchor) => {
							var fragment_4 = $.comment();
							var node_4 = $.first_child(fragment_4);

							Home(node_4, {});
							$.append($$anchor, fragment_4);
						};

						var d = $.derived(() => matchRoute('/'));

						var consequent_2 = ($$anchor) => {
							var fragment_5 = $.comment();
							var node_5 = $.first_child(fragment_5);

							NursingSession(node_5, {});
							$.append($$anchor, fragment_5);
						};

						var d_1 = $.derived(() => matchRoute('/session/nursing'));

						var consequent_3 = ($$anchor) => {
							var fragment_6 = $.comment();
							var node_6 = $.first_child(fragment_6);

							PumpingSession(node_6, {});
							$.append($$anchor, fragment_6);
						};

						var d_2 = $.derived(() => matchRoute('/session/pumping'));

						var consequent_4 = ($$anchor) => {
							var fragment_7 = $.comment();
							var node_7 = $.first_child(fragment_7);

							BottleFeed(node_7, {});
							$.append($$anchor, fragment_7);
						};

						var d_3 = $.derived(() => matchRoute('/session/bottle'));

						var consequent_5 = ($$anchor) => {
							var fragment_8 = $.comment();
							var node_8 = $.first_child(fragment_8);

							Log(node_8, {});
							$.append($$anchor, fragment_8);
						};

						var d_4 = $.derived(() => matchRoute('/log') || matchRoute('/log/*'));

						var consequent_6 = ($$anchor) => {
							var fragment_9 = $.comment();
							var node_9 = $.first_child(fragment_9);

							History(node_9, {});
							$.append($$anchor, fragment_9);
						};

						var d_5 = $.derived(() => matchRoute('/history'));

						var consequent_7 = ($$anchor) => {
							var fragment_10 = $.comment();
							var node_10 = $.first_child(fragment_10);

							Storage(node_10, {});
							$.append($$anchor, fragment_10);
						};

						var d_6 = $.derived(() => matchRoute('/storage') || matchRoute('/storage/*'));

						var consequent_8 = ($$anchor) => {
							var fragment_11 = $.comment();
							var node_11 = $.first_child(fragment_11);

							Health(node_11, {});
							$.append($$anchor, fragment_11);
						};

						var d_7 = $.derived(() => matchRoute('/health') || matchRoute('/health/*'));

						var consequent_9 = ($$anchor) => {
							var fragment_12 = $.comment();
							var node_12 = $.first_child(fragment_12);

							Analytics(node_12, {});
							$.append($$anchor, fragment_12);
						};

						var d_8 = $.derived(() => matchRoute('/analytics') || matchRoute('/analytics/*'));

						var consequent_10 = ($$anchor) => {
							var fragment_13 = $.comment();
							var node_13 = $.first_child(fragment_13);

							Reminders(node_13, {});
							$.append($$anchor, fragment_13);
						};

						var d_9 = $.derived(() => matchRoute('/reminders') || matchRoute('/reminders/*'));

						var consequent_11 = ($$anchor) => {
							var fragment_14 = $.comment();
							var node_14 = $.first_child(fragment_14);

							Sync(node_14, {});
							$.append($$anchor, fragment_14);
						};

						var d_10 = $.derived(() => matchRoute('/sync') || matchRoute('/sync/*'));

						var consequent_12 = ($$anchor) => {
							var fragment_15 = $.comment();
							var node_15 = $.first_child(fragment_15);

							Donate(node_15, {});
							$.append($$anchor, fragment_15);
						};

						var d_11 = $.derived(() => matchRoute('/donate') || matchRoute('/donate/*'));

						var consequent_13 = ($$anchor) => {
							var fragment_16 = $.comment();
							var node_16 = $.first_child(fragment_16);

							Export(node_16, {});
							$.append($$anchor, fragment_16);
						};

						var d_12 = $.derived(() => matchRoute('/export') || matchRoute('/export/*'));

						var consequent_14 = ($$anchor) => {
							var fragment_17 = $.comment();
							var node_17 = $.first_child(fragment_17);

							Profile(node_17, {});
							$.append($$anchor, fragment_17);
						};

						var d_13 = $.derived(() => matchRoute('/profile') || matchRoute('/profile/*'));

						var consequent_15 = ($$anchor) => {
							var fragment_18 = $.comment();
							var node_18 = $.first_child(fragment_18);

							Children(node_18, {});
							$.append($$anchor, fragment_18);
						};

						var d_14 = $.derived(() => matchRoute('/more/children') || matchRoute('/more/children/*'));

						var consequent_16 = ($$anchor) => {
							var fragment_19 = $.comment();
							var node_19 = $.first_child(fragment_19);

							Settings(node_19, {});
							$.append($$anchor, fragment_19);
						};

						var d_15 = $.derived(() => matchRoute('/more/settings'));

						var consequent_17 = ($$anchor) => {
							var fragment_20 = $.comment();
							var node_20 = $.first_child(fragment_20);

							More(node_20, {});
							$.append($$anchor, fragment_20);
						};

						var d_16 = $.derived(() => matchRoute('/more') || matchRoute('/more/*'));

						var alternate = ($$anchor) => {
							var fragment_21 = $.comment();
							var node_21 = $.first_child(fragment_21);

							Home(node_21, {});
							$.append($$anchor, fragment_21);
						};

						$.if(node_3, ($$render) => {
							if ($.get(d)) $$render(consequent_1); else if ($.get(d_1)) $$render(consequent_2, 1); else if ($.get(d_2)) $$render(consequent_3, 2); else if ($.get(d_3)) $$render(consequent_4, 3); else if ($.get(d_4)) $$render(consequent_5, 4); else if ($.get(d_5)) $$render(consequent_6, 5); else if ($.get(d_6)) $$render(consequent_7, 6); else if ($.get(d_7)) $$render(consequent_8, 7); else if ($.get(d_8)) $$render(consequent_9, 8); else if ($.get(d_9)) $$render(consequent_10, 9); else if ($.get(d_10)) $$render(consequent_11, 10); else if ($.get(d_11)) $$render(consequent_12, 11); else if ($.get(d_12)) $$render(consequent_13, 12); else if ($.get(d_13)) $$render(consequent_14, 13); else if ($.get(d_14)) $$render(consequent_15, 14); else if ($.get(d_15)) $$render(consequent_16, 15); else if ($.get(d_16)) $$render(consequent_17, 16); else $$render(alternate, -1);
						});
					}

					$.append($$anchor, fragment_3);
				},
				$$slots: { default: true }
			});

			$.append($$anchor, fragment_2);
		};

		$.if(node, ($$render) => {
			if (!$.get(appState).onboardingCompleted) $$render(consequent); else $$render(alternate_1, -1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	App = $.hmr(App);

	import.meta.hot.accept((module) => {
		App[$.HMR].update(module.default);
	});
}

export default App;